const firebaseConfig = {
    apiKey: "AIzaSyBlv4gZnsLwkQz6PXlw-xw2qxupd3g4EAI",
    authDomain: "sigma-hospital.firebaseapp.com",
    projectId: "sigma-hospital",
    storageBucket: "sigma-hospital.appspot.com",
    messagingSenderId: "1063130082908",
    appId: "1:1063130082908:web:67db16413798021bb2c099"
};
export default firebaseConfig;